class FieldPhoneNumber extends HTMLElement {
	connectedCallback() {
		this.field = this.querySelector('input[type="tel"]');
		if (!this.field) {
			console.error('FieldPhoneNumber: No input[type="tel"] found in the component.');
			return;
		}

		this.field.addEventListener('keypress', this.onKeyPress.bind(this));
		this.field.addEventListener('change', this.onChange.bind(this));
	}

	onKeyPress(event) {
		// Prevent non-telephone characters.
		const charCode = event.charCode || event.keyCode;
		const char = String.fromCharCode(charCode);
		const validChars = '0123456789+-() ';
		if (!validChars.includes(char)) event.preventDefault();

		// Change maxlength based on the style of phone number.
		if (this.field.value.startsWith('('))
			this.field.setAttribute('maxlength', '14');
		else if (this.field.value.includes('-'))
			this.field.setAttribute('maxlength', '12');
		else
			this.field.setAttribute('maxlength', '10');
	}

	onChange() {
		// Format phone number if it only includes digits.
		const symbols = this.field.value.replace(/\d/g, '');
		if (symbols.length === 0) {
			let formattedNumber = this.field.value.replace(/\D/g, '');
			if (formattedNumber.length > 3 && formattedNumber.length <= 6) {
				formattedNumber = `(${formattedNumber.slice(0, 3)}) ${formattedNumber.slice(3)}`;
			} else if (formattedNumber.length > 6) {
				formattedNumber = `(${formattedNumber.slice(0, 3)}) ${formattedNumber.slice(3, 6)}-${formattedNumber.slice(6)}`;
			} else {
				formattedNumber = formattedNumber.slice(0, 3);
			}
			this.field.value = formattedNumber;
		}
	}
}
customElements.define('field-phone-number', FieldPhoneNumber);